<template>
  <v-app>
    <div class="card card-custom">
      <div class="card-body p-0">
        <div
            class="wizard wizard-2"
            id="kt_wizard_v2"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
        >
          <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
            <!--begin: Wizard Form-->
            <div class="row">
              <div class="col-6">
                <h4>
                  Expiry Report
                </h4>
                <router-link :to="{ name: 'dashboard' }">
                  Dashboard
                </router-link>
                \
                Expiry
              </div>
              <div class="col-12 mt-2" v-if="upcoming_expiries.length>0">
                <h5>Upcoming expires [In 7 days from now]</h5>
                <table class="table">
                  <thead>
                  <th>Symbol no.</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Book Title</th>
                  <th>Book Author</th>
                  <th>Book Publisher</th>
                  <th>Book Publication</th>
                  <th>Issued Date</th>
                  <th>Due Date</th>
                  <th>Renew Date</th>
                  <th>Renew Day</th>
                  <th>Action</th>
                  </thead>
                  <tbody v-if="upcoming_expiries.length>0">
                  <tr v-for="(iss, i) of upcoming_expiries" :key="i">
                    <td @click="redirectTODetail(iss.user_id)" style="cursor: pointer">{{ iss.user_symbol_no }}</td>
                    <td @click="redirectTODetail(iss.user_id)" style="cursor: pointer">{{ iss.user_full_name }}</td>
                    <td>{{ iss.user_phone }}</td>
                    <td>{{ iss.user_email }}</td>
                    <td>{{ iss.book_title }}</td>
                    <td>{{ iss.book_author }}</td>
                    <td>{{ iss.book_publisher }}</td>
                    <td>{{ iss.book_publication }}</td>
                    <td>
                      <span class="badge badge-secondary">{{ iss.issue_date_text ? iss.issue_date_text : '-' }}</span>
                    </td>
                    <td>
                      <span class="badge badge-secondary">{{
                          iss.due_return_date_text ? iss.due_return_date_text : '-'
                        }}</span>
                    </td>
                    <td>
                      <span class="badge badge-secondary">{{ iss.renew_date_text ? iss.renew_date_text : '-' }}</span>
                    </td>
                    <td class="text-success font-weight-bold">{{iss.remaining_renew_day}}</td>
                    <td>
           <span>
            <i :class="iss.renew_required?'text-danger':'text-success'" class="fas fa-circle"></i></span>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <h4 class="text-center">No Data Found</h4>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12 mt-2" v-if="already_expired.length>0">
                <h5>Already Expired</h5>
                <table class="table">
                  <thead>
                  <th>Symbol no.</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Book Title</th>
                  <th>Book Author</th>
                  <th>Book Publisher</th>
                  <th>Book Publication</th>
                  <th>Issued Date</th>
                  <th>Due Date</th>
                  <th>Renew Date</th>
                  <th>Renew Day</th>
                  <th>Action</th>
                  </thead>
                  <tbody v-if="already_expired.length>0">
                  <tr v-for="(expired, i) of already_expired" :key="i">
<!--                    <pre>{{expired}}</pre>-->
                    <td @click="redirectTODetail(expired.user_id)" style="cursor: pointer">{{
                        expired.user_symbol_no
                      }}
                    </td>
                    <td @click="redirectTODetail(expired.user_id)" style="cursor: pointer">{{
                        expired.user_full_name
                      }}
                    </td>
                    <td>{{ expired.user_phone }}</td>
                    <td>{{ expired.user_email }}</td>
                    <td>{{ expired.book_title }}</td>
                    <td>{{ expired.book_author }}</td>
                    <td>{{ expired.book_publisher }}</td>
                    <td>{{ expired.book_publication }}</td>
                    <td>
                      <span class="badge badge-secondary">{{
                          expired.issued_date_text ? expired.issue_date_text : '-'
                        }}</span>
                    </td>
                    <td>
                      <span class="badge badge-secondary">{{
                          expired.due_return_date_text ? expired.due_return_date_text : '-'
                        }}</span>
                    </td>
                    <td>
                      <span class="badge badge-secondary">{{
                          expired.renew_date_text ? expired.renew_date_text : '-'
                        }}</span>
                    </td>
                    <td class="text-danger font-weight-bold">-{{expired.remaining_renew_day}}</td>
                    <td>
           <span>
            <i :class="expired.renew_required?'text-danger':'text-success'" class="fas fa-circle"></i></span>
<!--                      <span class="ml-3" @click="renewBook(expired)"><i-->
<!--                          class="fas fa-redo"></i></span>-->
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else>
                  <tr>
                    <td colspan="5">
                      <h4 class="text-center">No Data Found</h4>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import IssueService from "@/core/services/library/issue/IssueService";

const issueService = new IssueService();
export default {
  name: "Expiry",
  data() {
    return {
      upcoming_expiries: [],
      already_expired: [],
    }
  },
  mounted() {
    this.getExpiryReport()
  },
  methods: {
    getExpiryReport() {
      issueService.expiryReport().then(response => {
        this.upcoming_expiries = response.data.upcoming;
        this.already_expired = response.data.expired
      })
    },
    redirectTODetail(id){
      this.$router.push({name:'issue-return-detail', params:{id:id}})
    }
  }
}
</script>

<style scoped>

</style>